/*
 * Consignment form — v2
 * Repeatable "item" blocks (+ Add another item), display renumbering,
 * per-item photo count, and Formspree AJAX (multipart) submit.
 */
class ConsignmentForm extends HTMLElement {
  constructor() {
    super();
    this.counter = 1;
  }

  connectedCallback() {
    this.form = this.querySelector("form");
    this.itemsWrap = this.querySelector("[data-items]");
    this.template = this.querySelector("[data-item-template]");
    this.endpoint = this.getAttribute("data-endpoint") || "";
    this.successEl = this.querySelector(".consign-form__success");
    this.errorEl = this.querySelector(".consign-form__error");

    if (!this.form) return;

    this.reveal = this.querySelector("[data-reveal]");

    // Progressive enhancement: collapse only once JS is running, so no-JS
    // visitors still get the full form.
    if (this.reveal) this.classList.add("is-collapsed");

    this.addEventListener("click", (e) => {
      if (e.target.closest("[data-add-item]")) {
        e.preventDefault();
        this.addItem();
      } else if (e.target.closest("[data-remove]")) {
        e.preventDefault();
        this.removeItem(e.target.closest("[data-item]"));
      }
    });

    this.addEventListener("change", (e) => {
      if (e.target.matches("[data-photos-input]")) {
        this.updatePhotosCount(e.target);
      }
    });

    // The only trigger is the hero "Start Consigning" button, sitting on the
    // hero image (link to #consignment-form).
    document.addEventListener("click", (e) => {
      var trigger = e.target.closest('a[href="#consignment-form"], [data-consign-trigger]');
      if (trigger) {
        e.preventDefault();
        this.open(true);
      }
    });

    this.form.addEventListener("submit", (e) => this.onSubmit(e));
    this.refresh();
  }

  open(scrollIntoView) {
    if (this.classList.contains("is-collapsed")) {
      this.classList.remove("is-collapsed");
    }
    if (scrollIntoView) this.scrollToForm();
  }

  scrollToForm() {
    var section = this.closest(".consign-form") || this;
    section.scrollIntoView({ behavior: "smooth", block: "start" });
    var first = this.reveal && this.reveal.querySelector("input, select, textarea");
    if (first) {
      setTimeout(function () {
        first.focus({ preventScroll: true });
      }, 500);
    }
  }

  addItem() {
    if (!this.template || !this.itemsWrap) return;
    this.counter += 1;
    var html = this.template.innerHTML.replace(/__INDEX__/g, String(this.counter));
    var frag = document.createElement("div");
    frag.innerHTML = html.trim();
    var node = frag.firstElementChild;
    this.itemsWrap.appendChild(node);
    this.refresh();
    var firstField = node.querySelector("select, input, textarea");
    if (firstField) firstField.focus();
  }

  updatePhotosCount(input) {
    var label = input.closest("[data-photos]");
    var countEl = label && label.querySelector("[data-photos-count]");
    if (!countEl) return;
    var n = input.files ? input.files.length : 0;
    if (n > 0) {
      countEl.textContent = n === 1 ? "1 photo selected" : n + " photos selected";
      countEl.hidden = false;
    } else {
      countEl.hidden = true;
    }
  }

  removeItem(item) {
    if (!item) return;
    var items = this.items();
    if (items.length <= 1) return;
    item.remove();
    this.refresh();
  }

  items() {
    return Array.prototype.slice.call(this.itemsWrap.querySelectorAll("[data-item]"));
  }

  refresh() {
    var items = this.items();
    items.forEach(function (item, i) {
      var n = i + 1;
      var tag = item.querySelector("[data-item-tag]");
      if (tag) tag.textContent = "Item " + (n < 10 ? "0" + n : n);
      var remove = item.querySelector("[data-remove]");
      if (remove) remove.hidden = items.length <= 1;
    });
  }

  onSubmit(e) {
    e.preventDefault();
    if (!this.form.checkValidity()) {
      this.form.reportValidity();
      return;
    }
    if (!this.endpoint) return;

    var btn = this.form.querySelector("[type=submit]");
    if (btn) btn.disabled = true;
    var self = this;

    fetch(this.endpoint, {
      method: "POST",
      body: new FormData(this.form),
      headers: { Accept: "application/json" }
    })
      .then(function (res) {
        if (res.ok) {
          self.form.querySelectorAll("input, select, textarea, button").forEach(function (el) {
            el.disabled = true;
          });
          if (self.successEl) self.successEl.hidden = false;
          if (self.errorEl) self.errorEl.hidden = true;
          if (self.successEl) self.successEl.scrollIntoView({ behavior: "smooth", block: "center" });
        } else {
          return res.json().then(function (data) {
            var msg = data && data.errors
              ? data.errors.map(function (x) { return x.message; }).join(", ")
              : "Something went wrong. Please try again.";
            if (self.errorEl) {
              self.errorEl.textContent = msg;
              self.errorEl.hidden = false;
            }
            if (btn) btn.disabled = false;
          });
        }
      })
      .catch(function () {
        if (self.errorEl) {
          self.errorEl.textContent = "Network error. Please check your connection and try again.";
          self.errorEl.hidden = false;
        }
        if (btn) btn.disabled = false;
      });
  }
}

customElements.define("consignment-form", ConsignmentForm);
